// import React from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Header from "./component/layout/Header";
// import Footer from "./component/layout/Footer";
// import HomeScreen from "./component/screens/HomeScreen";
// import ChatScreen from "./component/screens/ChatScreen";
// import { ChatProvider } from "./component/screens/ChatContext";
// import "./App.css";
// import App1 from "./App1";

// const App = () => {
//   return (
//     <ChatProvider>
//       <Router>
//         <div className="app-container">
//           <Header />
//           <main>
//             <Routes>
//               <Route path="/" element={<HomeScreen />} exact />
//               <Route path="/chat" element={<ChatScreen />} />
//               <Route path="/trade" element={<App1 />} />
//             </Routes>
//           </main>
//           <Footer />
//         </div>
//       </Router>
//     </ChatProvider>
//   );
// };

// export default App;

import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./component/layout/Header";
import Footer from "./component/layout/Footer";
import HomeScreen from "./component/screens/HomeScreen";
import ChatScreen from "./component/screens/ChatScreen";
import { ChatProvider } from "./component/screens/ChatContext";
import "./App.css";
import App1 from "./App1";
import { MsalProvider } from '@azure/msal-react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';
import { b2cPolicies } from './Auth/authConfig';
import { compareIssuingPolicy } from './Auth/claimUtils';
import Login from './login';

const App = ({ instance1 }) => {
  useEffect(() => {
    const callbackId = instance1.addEventCallback((event) => {
      if (
        (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        event.payload.account
      ) {
        // Handle profile edit flow
        if (event.payload.idTokenClaims['tfp'] === b2cPolicies.names.editProfile) {
          const originalSignInAccount = instance1
            .getAllAccounts()
            .find(
              (account) =>
                account.idTokenClaims.oid === event.payload.idTokenClaims.oid &&
                account.idTokenClaims.sub === event.payload.idTokenClaims.sub &&
                account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn
            );

          let signUpSignInFlowRequest = {
            authority: b2cPolicies.authorities.signUpSignIn.authority,
            account: originalSignInAccount,
          };

          instance1.ssoSilent(signUpSignInFlowRequest);
        }

        // Handle password reset flow
        if (compareIssuingPolicy(event.payload.idTokenClaims, b2cPolicies.names.forgotPassword)) {
          let signUpSignInFlowRequest = {
            authority: b2cPolicies.authorities.signUpSignIn.authority,
          };
          instance1.loginRedirect(signUpSignInFlowRequest);
        }
      }

      if (event.eventType === EventType.LOGIN_FAILURE) {
        if (event.error && event.error.errorMessage.includes('AADB2C90118')) {
          const resetPasswordRequest = {
            authority: b2cPolicies.authorities.forgotPassword.authority,
            scopes: [],
          };
          instance1.loginRedirect(resetPasswordRequest);
        }
      }
    });

    return () => {
      if (callbackId) {
        instance1.removeEventCallback(callbackId);
      }
    };
  }, [instance1]);

  return (
    <ChatProvider>
      <MsalProvider instance={instance1}>
        <Router>
          <div className="app-container">
            <AuthenticatedTemplate>
              <Header />
              <main>
                <Routes>
                  <Route path="/devtradingui" element={<HomeScreen />} exact />
                  <Route path="/devtradingui/chat" element={<ChatScreen />} />
                  <Route path="/devtradingui/trade" element={<App1 />} />
                </Routes>
              </main>
              <Footer />
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
              <Login />
            </UnauthenticatedTemplate>
          </div>
        </Router>
      </MsalProvider>
    </ChatProvider>
  );
};

export default App;
